// Shared constants/helpers for the Real-Time Monitoring feature.
// Uses the existing ChickFarm green theme (primary #1e5c33 / secondary #7caf64)
// with conventional amber/red accents for caution/critical states.

export const STATUS_META = {
  optimal: {
    label: 'Optimal',
    text: 'text-green-700',
    bg: 'bg-green-50',
    badgeBg: 'bg-green-100',
    border: 'border-green-200',
    dot: 'bg-green-500',
    chart: '#1e5c33',
  },
  caution: {
    label: 'Caution',
    text: 'text-amber-700',
    bg: 'bg-amber-50',
    badgeBg: 'bg-amber-100',
    border: 'border-amber-200',
    dot: 'bg-amber-500',
    chart: '#d97706',
  },
  critical: {
    label: 'Critical',
    text: 'text-red-700',
    bg: 'bg-red-50',
    badgeBg: 'bg-red-100',
    border: 'border-red-200',
    dot: 'bg-red-500',
    chart: '#dc2626',
  },
};

export const METRICS = [
  { key: 'temperature', label: 'Temperature', unit: '°C', decimals: 1 },
  { key: 'humidity', label: 'Humidity', unit: '%', decimals: 0 },
  { key: 'co2', label: 'CO₂', unit: 'ppm', decimals: 0 },
  { key: 'ammonia', label: 'Ammonia', unit: 'ppm', decimals: 1 },
];

export const RANGES = [
  { key: '24h', label: '24h' },
  { key: '7d', label: '7 days' },
  { key: '30d', label: '30 days' },
];

export function statusMeta(status) {
  return STATUS_META[status] || STATUS_META.optimal;
}

export function formatValue(value, decimals = 1) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return Number(value).toFixed(decimals);
}

export function formatTimestamp(ts) {
  if (!ts) return '—';
  const d = new Date(ts);
  return d.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function timeAgo(ts) {
  if (!ts) return 'never';
  const diff = Date.now() - new Date(ts).getTime();
  const s = Math.floor(diff / 1000);
  if (s < 10) return 'just now';
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

// Worst per-metric status across a reading.
export function worstStatusOf(reading) {
  if (!reading?.statuses) return 'optimal';
  const rank = { optimal: 0, caution: 1, critical: 2 };
  return Object.values(reading.statuses).reduce(
    (worst, s) => (rank[s] > rank[worst] ? s : worst),
    'optimal'
  );
}
